import { ParamsType } from "../api"

export function querify(obj: ParamsType) {
    const qs = new URLSearchParams()

    for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            const val = obj[key]
            if (val || typeof val === "boolean") {
                if (Array.isArray(val)) {
                    for (const i in val) {
                        qs.append(key, val[i])
                    }
                } else {
                    qs.append(key, val)
                }
            }
        }
    }

    return qs
}
